import { getFormatDate, getShortId } from '@/utils/format-strings'

export function getCookedTime(date, status) {
  if (date) {
    if (status && this.orderStatuses[status].order_number >= this.orderStatuses.cooked.order_number) {
      return this.getFormatDate(date)
    }
    const dateNow = this.$moment()
    const coockedDate = this.$moment(date)
    const diff = coockedDate.diff(dateNow, 'seconds')
    return diff <= 0 ? '' : `${Math.ceil(diff / 60)} мин`
  }
  return ''
}

export default {
  methods: {
    getFormatDate,
    getShortId,
    getCookedTime
  }
}